/**
 * Constants for Intercom event names.
 *
 * These constants ensure consistency in event naming for Intercom tracking.
 */
export const INTERCOM_EVENTS = {
  /** Triggered when a user successfully adds their first camera to a studio */
  FIRST_CAMERA_ADDED: 'first-camera-added',
  /** Triggered when a user accesses the Electron app for the first time */
  FIRST_TIME_ELECTRON_ACCESS: 'first-time-electron-access'
} as const;

export type IntercomEventName = (typeof INTERCOM_EVENTS)[keyof typeof INTERCOM_EVENTS];
